import { ajax } from './index';
import storage from '../../services/localStorage';
import { api } from '../../constants';

export function setupAjax() {
  ajax
    .createHttpInstance({
      baseURL: api.baseURL,
      tokenKey: 'X-BT-TOKEN'
    })
    .setStorageAdapter(storage)
    .sendOnRequests([{ token: 'X-BT-TOKEN' }]);
}
